module.exports = __webpack_public_path__ + "img/50x50_shouhou@2x.b293c74b.png";